import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".75",
      d: "M2.5 5.25H1.347a.25.25 0 0 1-.237-.33l.72-2.157a.75.75 0 0 1 .71-.513h6.92a.75.75 0 0 1 .71.513l.72 2.158a.25.25 0 0 1-.237.329H9.5m-7 0V9c0 .414.336.75.75.75h2.5A.75.75 0 0 0 6.5 9V5.25m-4 0h4m0 0h3m0 0v4.5"
    }, null, -1)
  ]))]))
}
export default { render: render }